<template>
  <div class="conectar-assistente">
    <div class="card">
      <h3>{{ titulo }}</h3>
      <p v-if="mensagem" class="mensagem">{{ mensagem }}</p>
      <b-spinner v-if="carregando" label="Conectando" />
      <b-button v-if="erro" variant="primary" @click="tentarNovamente">
        Tentar novamente
      </b-button>
    </div>
  </div>
</template>

<script>
/**
 * Ponte de login do MCP "Wellon Gestão" (WEL-5286).
 *
 * O assistente de IA (Claude, ChatGPT) manda o usuário para cá. Com ele já
 * autenticado no painel — por senha, SSO ou segundo fator, tanto faz —
 * pedimos um código à API e devolvemos o usuário ao MCP levando esse código.
 *
 * O MCP nunca vê credencial: ele troca o código pelo token depois, servidor a
 * servidor. Se o usuário ainda não estiver logado, guardamos o destino e o
 * mandamos ao login; o Login-1 devolve ele para cá ao concluir.
 */
import ApiService from "@/core/services/api.service";

export const CHAVE_RETORNO = "retornoAposLogin";

export default {
  name: "ConectarAssistente",
  data() {
    return {
      carregando: true,
      erro: false,
      mensagem: ""
    };
  },
  computed: {
    titulo() {
      return this.erro
        ? "Não foi possível conectar"
        : "Conectando seu assistente";
    }
  },
  mounted() {
    this.conectar();
  },
  methods: {
    async conectar() {
      const { redirect_uri: redirectUri, txn } = this.$route.query;

      // Sem os parâmetros do assistente não há o que autorizar — evita que a
      // página seja usada para emitir código fora do fluxo.
      if (!redirectUri || !txn) {
        return this.falhar(
          "Link inválido. Refaça a conexão a partir do seu assistente."
        );
      }

      if (!this.$store.getters.isAuthenticated) {
        // Guarda o destino e manda para o login; voltamos para cá depois.
        sessionStorage.setItem(CHAVE_RETORNO, this.$route.fullPath);
        return this.$router.push({ name: "login" });
      }

      try {
        const resposta = await ApiService.post("oauth/gerar-codigo", {
          redirect_uri: redirectUri
        });

        const codigo = resposta.data.data.codigo;
        const separador = redirectUri.includes("?") ? "&" : "?";

        // Sai do painel: devolve o usuário ao MCP levando o código.
        window.location.href =
          `${redirectUri}${separador}txn=${encodeURIComponent(txn)}` +
          `&codigo=${encodeURIComponent(codigo)}`;
      } catch (e) {
        this.falhar(
          "Não foi possível autorizar a conexão. Se o problema persistir, " +
            "fale com o suporte da Wellon."
        );
      }
    },
    falhar(mensagem) {
      this.carregando = false;
      this.erro = true;
      this.mensagem = mensagem;
    },
    tentarNovamente() {
      this.carregando = true;
      this.erro = false;
      this.mensagem = "";
      this.conectar();
    }
  }
};
</script>

<style scoped>
.conectar-assistente {
  display: flex;
  align-items: center;
  justify-content: center;
  /* Renderiza fora do Layout: ocupa a tela inteira, não a área de conteúdo. */
  min-height: 100vh;
}
.card {
  padding: 32px;
  text-align: center;
  max-width: 420px;
}
.mensagem {
  margin: 12px 0 20px;
}
</style>
